import { connect } from 'react-redux';
import { apiPatchDispatchableWithoutSource } from '../../../core/dapi';
import { getAccountById } from '../../../core/dapi/account';
import { receiveAccount, accountError } from '../../../actions/account';
import { dataBasePhoneValueToTenDigitDisplayPhone } from '../../../core/util/phoneNumber';
import EditAccountForm from '../../../components/Account/EditAccountForm';
import {
  FETCH_WEB_PUSH_SUBSCRIPTION,
  DELETE_WEB_PUSH_SUBSCRIPTION,
} from '../../../sagas/webPushSubscriptions';
import history from '../../../core/history';

const mapStateToProps = (state: any) => ({
  accountId: state.account.summary.id,
  isUpdatingAccount: state.runtime.isUpdatingAccount,

  initialValues: {
    email: state.account.summary.email,
    phone: dataBasePhoneValueToTenDigitDisplayPhone(state.account.summary.phone),
  },

  accountWebPushSubscription: state.webPushSubscriptions.result,
});

const mapDispatchToProps = (dispatch: any) => ({
  fetchAccountWebPushSubscription: (accountId: any) =>
    dispatch({
      type: FETCH_WEB_PUSH_SUBSCRIPTION,
      accountId,
    }),

  deleteAccountWebPushSubscription: (subscriptionId: any) =>
    dispatch({
      type: DELETE_WEB_PUSH_SUBSCRIPTION,
      subscriptionId,
    }),

  updateAccount: (accountId: any, data: any) => {
    const updateAccountSuccess = (value: any) => {
      history.push('/account/home');
      return receiveAccount(value);
    };

    const updateAccountError = (value: any) => accountError(value);

    dispatch(
      apiPatchDispatchableWithoutSource(
        getAccountById(accountId),
        data,
        updateAccountSuccess,
        updateAccountError
      )
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(EditAccountForm);
